import styles from './inner_page_container.module.css'
export default function InnerPageContainer(props) {
  var extraStyles = {};
  if (props.backgroundColor) extraStyles["backgroundColor"] = props.backgroundColor;
  return (
    <div className={`${props.fullWidth ? styles.mainFullWidth : styles.main} ${props.homeHeroHost ? styles.homeHeroHost : ""}`} style={extraStyles}>
        {props.children}
    </div>
  )
}